import { render } from "./PermissionsTree.vue?vue&type=template&id=a83d3354&ts=true"
import script from "./PermissionsTree.vue?vue&type=script&lang=ts"
export * from "./PermissionsTree.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__